// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3OpDO","content":"styles_content__3aWaj","selectAll":"styles_selectAll__VR2ah"};